import { showPanelView } from '@/lib/side-panel/panel-tabs';
import type { DesktopShellStore } from './store';

/** The share of the window an artifact's panel takes at least (design D15: a wide panel). */
const WIDE_ARTIFACT_PANEL = 55;

/**
 * Docks an artifact in the conversation on screen: its type's view in a tab of the side panel,
 * the panel widened to show it (design D15); a wider or maximized panel stays as it is, and it is
 * never maximized for it. On a phone the panel is the screen (mobile 12). Every way to an
 * artifact from a conversation comes here (cards, references, the agent's `show`, an app's
 * `view.open`, the sidebar).
 */
export function dockArtifact(store: DesktopShellStore, artifactId: string): void {
  const state = store.getState();
  state.setPanelTabs((tabs) => showPanelView(tabs, `artifact:${artifactId}`));
  if (state.panelSize < WIDE_ARTIFACT_PANEL) state.setPanelSize(WIDE_ARTIFACT_PANEL);
  state.setSidePanelOpen(true);
}
